import update from 'immutability-helper';
import { REPORTS } from '../constants';

export const initialState = {
  isLoading: false,
  isCompleted: false,
  data: [],
  params: {},
  total: 0,
  currentPage: 1,
  summary: {
    statuses: {
      save: 0,
      paused: 0,
      schedule: 0,
      sending: 0,
      sent: 0,
      problem: 0,
      skipped: 0,
    },
    isLoaded: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REPORTS.FETCH.REQUEST:
      return update(state, {
        isLoading: { $set: true },
        isCompleted: { $set: false },
      });
    case REPORTS.FETCH.SUCCESS:
      return update(state, {
        isLoading: { $set: false },
        isCompleted: { $set: true },
        data: { $set: action.payload.data },
        total: { $set: action.payload.total },
        currentPage: { $set: action.payload.current_page },
      });
    case REPORTS.FETCH.FAILURE:
      return update(state, {
        isLoading: { $set: false },
        isCompleted: { $set: true },
      });
    case REPORTS.ADD_DATA:
      return update(state, {
        data: { $splice: [[0, 0, action.item]] },
      });
    case REPORTS.UPDATE_DATA:
      return update(state, {
        data: {
          $apply: b => b.map((item) => {
            if (item.id === action.item.id) {
              return action.item;
            }
            return item;
          }),
        },
      });
    case REPORTS.SUMMARY.SUCCESS:
      return update(state, {
        summary: {
          $set: {
            ...action.payload,
            isLoaded: true,
          },
        },
      });
    case REPORTS.SUMMARY.RESET:
    case REPORTS.SUMMARY.FAILURE:
      return update(state, {
        summary: {
          statuses: {
            save: { $set: 0 },
            paused: { $set: 0 },
            schedule: { $set: 0 },
            sending: { $set: 0 },
            sent: { $set: 0 },
            problem: { $set: 0 },
            skipped: { $set: 0 },
          },
          isLoaded: { $set: true },
        },
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/reports.reducer.js